import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import ErrorModal from '../Modal/ErrorModal';
import {AppRoute} from '../../routes/Route';
import {LightWrapperStyled, BackgroundImg, StickyMobileHeader, AppWrapper} from './template.style';
import LightHeader from '../LightHeader/LightHeader';
import {getBackgroundImage} from '../../helpers/string.helper';
import {isRestaurantOpen} from '../../helpers/date.helper';
import {Footer} from '../../containers/LightHomePage/Footer';
import SmartBanner from '../SmartBanner/SmartBanner';

class LightTemplate extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showHeader: props.location.pathname !== '/'
    };
  }

  componentWillUpdate(nextProps) {
    const {location} = this.props;
    // Hiding header on homepage
    if (location !== nextProps.location) {
      if (location.pathname === '/') {
        this.setState({showHeader: true});
      }
      if (nextProps.location.pathname === '/') {
        this.setState({showHeader: false});
      }
    }
  }

  render() {
    const {restaurant, serverOffline, config, navUrls} = this.props;
    const isOpen = isRestaurantOpen(restaurant.openingTimes, restaurant.modes, serverOffline);
    const backgroundImageUrl = restaurant.backgroundImages && restaurant.backgroundImages.desktop;
    const backgroundImages = getBackgroundImage(backgroundImageUrl);
    const bgImage = backgroundImages && backgroundImages.desktop;
    const renderHeader = this.state.showHeader && (
      <StickyMobileHeader>
        <LightHeader
          restaurant={restaurant}
          isOpen={isOpen}
          navUrls={navUrls}
        />
      </StickyMobileHeader>
    );
    const isTemplateLight = restaurant && restaurant.template && restaurant.template.light;
    const firstColor = isTemplateLight && restaurant.template.light.brandFirstColour;
    const secondColor = isTemplateLight && restaurant.template.light.brandSecondColour;
    const renderBackground = this.state.showHeader && bgImage && (
      <BackgroundImg backgroundImages={bgImage} />
    );
    const renderSmartBanner = (
      <SmartBanner
        position="top"
        force={config.mobileOS}
      />
    );
    return (
      <LightWrapperStyled
        firstColor={firstColor}
        secondColor={secondColor}
      >
          <ErrorModal />
          {renderHeader}
          {renderSmartBanner}
          <AppWrapper extraMargin={this.state.showHeader}>
            <AppRoute light={true} />
          </AppWrapper>
          {renderBackground}
          <Footer
            revert={this.state.showHeader}
            name={restaurant.name}
            navUrls={navUrls}
          />
      </LightWrapperStyled>
    );
  }
}

LightTemplate.propTypes = {
  config: PropTypes.object.isRequired,
  restaurant: PropTypes.object.isRequired,
  location: PropTypes.object,
  serverOffline: PropTypes.bool.isRequired,
  navUrls: PropTypes.object
};

export default LightTemplate;



// WEBPACK FOOTER //
// ./components/ThemeAllocator/LightTemplate.js